import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Input,
  ControlLabel,
  Message,
  Checkbox,
  CheckboxGroup,
  Row,
  Col,
} from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  updateRequestDocument,
  updateUncertified,
  updateSignContract,
} from '../../redux/actions/contract'
import pathname from '../../constants/pathname'

export default function CenterOfferAuthorizedSignatoryStaffPanel(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit, isRequestMore, isUncetified } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [checkBoxList, setCheckBoxList] = useState([])

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    if (schema.contractFileType) {
      if (
        Array.isArray(schema.contractFileType.optionSelected) &&
        schema.contractFileType.optionSelected.length > 0
      ) {
        console.log(
          'schema.contractFileType.optionSelected',
          schema.contractFileType.optionSelected
        )
        // setCheckBoxList(schema.contractFileType.optionSelected)
        // setValue(schema.contractFileType.name, schema.contractFileType.optionSelected)
        setValue(schema.contractFileType.name)
      } else {
        setValue(schema.contractFileType.name)
      }
    }
  }, [schema.contractFileType])

  const handleCallService = async () => {
    setShowConfirm(false)
    let request = {
      projectVersionId: projectId,
      userId: '',
      value: memo,
      selectedContractFileType: schema?.contractFileType ? checkBoxList : [],
    }
    console.log(JSON.stringify(request))
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      var response
      if (isRequestMore) {
        response = await updateRequestDocument(request, projectId)
      } else if (isUncetified) {
        response = await updateUncertified(request, projectId)
      } else {
        response = await updateSignContract(request, projectId)

        if (response.success) {
          //success jump to new page
          setShowConfirm(false)
          setIsError(false)
          doneLoading()
          setIsLoading(false)

          sessionStorage.setItem('projectId', response.model.projectVersionId)
          sessionStorage.setItem('param', '')

          return history.push(
            // `${pathname.proposal.overview.overviewCoworker}/${response.model.projectVersionId}`
            `${pathname.proposal.overview.overviewCoworker}`
          )
        } else {
          setShowConfirm(false)
          setIsError(response.errorMessage)
          return
        }
      }

      if (response) {
        //success jump to new page
        setShowConfirm(false)
        setIsError(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
      setShowConfirm(false)
    } catch (e) {
      setShowConfirm(false)
      console.log(e?.response?.data)
      if (e?.response?.data) {
        setIsError(e?.response?.data?.errorMessage)
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    setMemo(data.note)
    setShowConfirm(true)
    console.log(checkBoxList)
  }

  const handleChange = (value) => {
    if (value.length === 0) {
      setValue(schema.contractFileType.name)
    } else {
      setValue(schema.contractFileType.name, value)
    }
    setCheckBoxList(value)
  }

  const generateCheckbox = () => {
    return schema.contractFileType.options.map((item, index) => {
      return (
        <>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Checkbox value={item.value} disabled={item.disabled}>
                {item.label}
              </Checkbox>
            </Col>
          </Row>
        </>
      )
    })
  }

  return (
    <div>
      <Panel
        header={schema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 10 }}
      >
        <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
        <ErrorMessage error={errors[schema.note.name]} />
        <br />
        <Input
          name={schema.note.name}
          inputRef={register(isValidators(schema.note.validators))}
          rows={3}
          placeholder={schema.note.label}
          componentClass="textarea"
          defaultValue={schema.note.value}
        />

        {schema.contractFileType && (
          <>
            <br />
            <ControlLabel>{schema.contractFileType.label}</ControlLabel>
            {errors[schema.contractFileType.name] && (
              <Message
                showIcon
                type="error"
                description={errors[schema.contractFileType.name].message}
              />
            )}
            <Controller
              key={schema.contractFileType.name}
              name={schema.contractFileType.name}
              control={control}
              rules={isValidators(schema.contractFileType.validators)}
              // value={item.numberOfPeople.value}
              defaultValue={checkBoxList}
              render={(props) => {
                return (
                  <CheckboxGroup
                    name={schema.contractFileType.name}
                    value={checkBoxList}
                    onChange={handleChange}
                  >
                    {generateCheckbox()}
                  </CheckboxGroup>
                )
              }}
            />
          </>
        )}

        {showCommandButton && (
          <>
            <hr />
            {isError && <Message showIcon type="error" description={isError} />}

            <Button
              style={{ width: 'auto' }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={isLoading}
            >
              {schema.buttonText}
            </Button>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
